var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[(_vm.includeModel)?_c('b-img',{attrs:{"src":_vm.url,"thumbnail":"","fluid":""}}):_vm._e(),(_vm.includeText)?_c('b-img',{attrs:{"src":_vm.txtUrl,"thumbnail":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }